import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import vrTheme from '@vr/lib/styles/theme';
import { VRPAT, JVCEF } from '~/config/constants';
import { getIssuer } from '~/helpers/getIssuer';

export const jvcefTheme = {
  ...vrTheme,
  name: JVCEF,
  colors: {
    ...vrTheme?.colors,
    primary: '#195C9D',
    secondary: '#EA8A3A',

    institucional: '#195C9D',
    institucionalDark: 'white',
    negativoColor: '#18548E',
    institucionalLight: '#195C9D',
    institucionalComplement: '#195C9D',
  },
};

const basePalette = {
  [VRPAT]: {
    primary: {
      main: vrTheme.colors.primary,
    },
    secondary: {
      main: vrTheme.colors.secondary,
    },
    error: {
      main: vrTheme.colors.danger,
    },
    warning: {
      main: vrTheme.colors.warning,
    },
  },
  [JVCEF]: {
    primary: {
      main: jvcefTheme.colors.primary,
    },
    secondary: {
      main: jvcefTheme.colors.secondary,
    },
    error: {
      main: jvcefTheme.colors.danger,
    },
    warning: {
      main: jvcefTheme.colors.warning,
    },
  },
};

const issuer = getIssuer();
const fontName = issuer === JVCEF ? 'Futura' : 'Montserrat';

const MaterialProvider = ({ children, issuer }) => {
  const materialResetTheme = {
    typography: {
      fontFamily: `${fontName}, sans-serif;`,
      fontSize: 14,
    },
    palette: {
      ...basePalette[issuer],
    },
  };

  const theme = createMuiTheme(materialResetTheme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

MaterialProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.object,
  ]),
};

export default MaterialProvider;
